export const FEEDBACK_SEND_SUCCESSFULLY =
  'Обращение в службу технической поддержки ФГИС ЕРКНМ и ее подсистемы ЕРП успешно зарегистрировано. Номер обращения будет направлен на указанную в обращении почту.';
export const FEEDBACK_SEND_ERROR = 'Ошибка отправки';
export const INTERNAL_SERVER_ERROR = 'Внутренняя ошибка сервера';
